module.exports = __webpack_public_path__ + "static/media/view2.53afc17b.jpg";